import * as React from "react";
import { useTranslations } from "../../i18n/useTranslations";
import { useMenu } from "../../Menu/useMenu";
import { hrefToDashes } from "../../utils";

export const TrackingButton = () => {
	const { t } = useTranslations();
	const { tracking: item } = useMenu().items;

	return (
		<div className="elm-w-10 elm-h-10 elm-rounded-full elm-cursor-pointer elm-pointer-events-auto elm-transition lg:hover:elm-bg-dd-blue-100">
			<a
				className="focus:elm-outline-none elm-block elm-rounded-full"
				tabIndex={0}
				data-track-label={`link:${hrefToDashes(item.href)}`}
				href={item.href}
				target="_parent"
				title={t("My tracking")}
				aria-label={t("My tracking")}
			>
				<TrackingIcon />
			</a>
		</div>
	);
};

function TrackingIcon() {
	return (
		<span className="elm-w-10 elm-h-10 elm-flex elm-justify-center elm-items-center elm-transition elm-pointer-events-none">
			<svg
				width="23"
				height="23"
				viewBox="0 0 23 23"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<mask id="path-1-inside-1_693:5561" fill="white">
					<rect x="0.75" y="0.106445" width="6" height="22" rx="1" />
				</mask>
				<rect
					x="0.75"
					y="0.106445"
					width="6"
					height="22"
					rx="1"
					className="elm-stroke-current elm-text-dd-blue-900"
					strokeWidth="2.6"
					mask="url(#path-1-inside-1_693:5561)"
				/>
				<mask id="path-2-inside-2_693:5561" fill="white">
					<rect x="8.75" y="4.10645" width="6" height="18" rx="1" />
				</mask>
				<rect
					x="8.75"
					y="4.10645"
					width="6"
					height="18"
					rx="1"
					className="elm-stroke-current elm-text-dd-blue-900"
					strokeWidth="2.6"
					mask="url(#path-2-inside-2_693:5561)"
				/>
				<mask id="path-3-inside-3_693:5561" fill="white">
					<rect x="16.75" y="10.1064" width="6" height="12" rx="1" />
				</mask>
				<rect
					x="16.75"
					y="10.1064"
					width="6"
					height="12"
					rx="1"
					className="elm-stroke-current elm-text-dd-blue-900"
					strokeWidth="2.6"
					mask="url(#path-3-inside-3_693:5561)"
				/>
			</svg>
		</span>
	);
}
